var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex fd-column jc-between"},[_c('portal',{attrs:{"to":"MODAL"}},[_c('view-review-modal',{attrs:{"review":_vm.modalData},on:{"close":_vm.next}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }